import React from 'react';

import type { TableProps } from './Table';

type UseTableColumnResizeProps = {
  structure?: TableProps['structure'];
};

export function useTableColumnResize({ structure }: UseTableColumnResizeProps) {
  const [columnWidths, setColumnWidths] = React.useState(structure?.columnWidths);

  const handleChangeStructure: (structure: TableProps['structure']) => void = struct =>
    setColumnWidths(struct?.columnWidths);

  return { columnWidths, handleChangeStructure };
}
